import { createApp } from 'vue'
import App from './App.vue'
import "./assets/tailwind.css";
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'

const app = createApp(App);
app.use(VueSweetalert2);
window.Swal =  app.config.globalProperties.$swal;

let baseUrl="https://mandate-crm.propertypistol.com/api/";
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://mandate-crm.propertypistol.com/api/";
}
axios.defaults.baseURL = baseUrl;
axios.defaults.headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
//   Authorization: `Token token=${token}`
}
router.beforeEach((to, from, next) => {
  if(to.name === undefined){
    next({ name: "index" });
  } else {
    next()
  }
})

app.config.globalProperties.$axios = axios;
app.config.productionTip = false

app.use(router).mount('#app')
